module.exports = __webpack_public_path__ + "static/media/bar-chart-icon.5a398def.svg";